export class AssignAttendeeTable {
  public AttendeeHeaderIds: Array<number>;
  public TableName: string;

  public constructor() {
    this.AttendeeHeaderIds = new Array<number>();
    this.TableName = '';
  }
}
